import React, { useState } from 'react';
import './Customer.css';
import moment from 'moment-jalaali'
import { toPersian } from 'persian';
import { Alert, Card, Collapse } from 'react-bootstrap';
import moneyImage from './../../images/money.png'
import clockImage from './../../images/clock.png'
import routerImage from './../../images/router.png'
import pcposImage from './../../images/pcpos.png'
import printerImage from './../../images/printer2.png'
import ordersImage from './../../images/orders.jpg'
import settingImage from './../../images/settings.png'
import lockImage from './../../images/lock.png'
import zipImage from './../../images/zip.png'
import backupImage from './../../images/backup.jpg'
import envelopeImage from './../../images/envelope.png'
import priceFormat from '../../service/showPriceFormat';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
import config from './../../config.json';

const Customer = ({ number, customer, color, admin, setCustomerForLicense, setCustomerForInfo, setCustomerForPayment, setCustomerForDelete, setCustomerForMenu, setCustomerForSmsPanel }) => {

    const [showCollapse, setShowCollapse] = useState(false);

    const getPaymentStatus = () => {
        let payFlag = (!customer.payment || !customer.payment.length) ? false : true;
        if (!payFlag) {
            return false;
        }
        else {
            customer.payment.forEach(element => {
                !element.done && (payFlag = false)
            });
        }
        return payFlag;
    }
    const getPrintServices = () => {
        let arr = [0, 0, 0, 0, 0, 0];
        customer.printServices && customer.printServices.s1 && (arr[0] = customer.printServices.s1)
        customer.printServices && customer.printServices.s2 && (arr[1] = customer.printServices.s2)
        customer.printServices && customer.printServices.s3 && (arr[2] = customer.printServices.s3)
        customer.printServices && customer.printServices.s4 && (arr[3] = customer.printServices.s4)
        customer.printServices && customer.printServices.s5 && (arr[4] = customer.printServices.s5)
        customer.printServices && customer.printServices.s6 && (arr[5] = customer.printServices.s6)
        return arr;
    }
    const hasPrintServices = () => {
        if (!customer.printServices) {
            return false
        }
        else if (
            !customer.printServices.s1 &&
            !customer.printServices.s2 &&
            !customer.printServices.s3 &&
            !customer.printServices.s4 &&
            !customer.printServices.s5 &&
            !customer.printServices.s6
        ) {
            return false
        }
        else {
            return true;
        }
    }
    const getServiceName = (serviceLabel) => {
        let name;
        const arr = getPrintServices()
        serviceLabel === 's1' && (name = arr[0])
        serviceLabel === 's2' && (name = arr[1])
        serviceLabel === 's3' && (name = arr[2])
        serviceLabel === 's4' && (name = arr[3])
        serviceLabel === 's5' && (name = arr[4])
        serviceLabel === 's6' && (name = arr[5])
        return name;
    }
    const handleDownloadBackup = (backupName) => {
        try {
            const fileUrl = `${config.download_address}/${backupName}`;
            const link = document.createElement('a');
            link.href = fileUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (err) {
            const error = new Error(err);
            toast.error(error.message)
        }
    }


    return (
        <div className='customer-card shadow' onClick={() => setShowCollapse(prev => !prev)}>
            <div className='col-6 d-flex'>
                <span className={`text-${color} ml-3`}>{number}
                </span>
                <div className='rtl'>{customer.nickName}</div>
            </div>
            <div className='col' style={{ fontSize: '1.1rem' }}>
                <img src={moneyImage} alt='' />
                {
                    getPaymentStatus() ?
                        <i className='fa fa-check text-success mr-2' style={{ width: '30px', textAlign: 'right' }}></i>
                        :
                        <i className='fa fa-exclamation text-danger mr-2' style={{ width: '30px', textAlign: 'right' }}></i>
                }
            </div>
            <div className='col' style={{ fontSize: '.8rem' }}>
                <span>
                    {
                        customer.expireTimeStamp && toPersian(moment(customer.expireTimeStamp).utc(false).add('3.5', 'hours').format('jYYYY/jMM/jDD'))
                    }
                </span>
                <img src={clockImage} alt='' />
            </div>
            <section className='col-12 '>
                <Collapse
                    in={showCollapse}
                >
                    <div onClick={e => e.stopPropagation()}>
                        <div className='row mt-3 rtl collapse-div' >
                            <div className='col-12 col-sm-6 mb-3' style={{ fontSize: '.8rem' }}>
                                <i className='fa fa-user mr-2'></i>
                                نام لاتین:<span className='text-muted ml-2 ltr'>{customer.companyName}</span>
                            </div>
                            <div className='col-12 col-sm-6 mb-3 ' style={{ fontSize: '.8rem' }}>
                                <i className='fa fa-phone mr-2'></i>
                                تلفن:<span className='text-muted ml-2'>{toPersian(String(customer.companyTel || '------'))}</span>
                            </div>
                            <div className='col-12 mb-2' style={{ fontSize: '.8rem' }}>
                                <i className='fa fa-map-marker mr-2'></i>
                                آدرس:<span className='text-muted ml-2'>{toPersian(String(customer.companyTitle || '------'))}</span>
                            </div>
                            <div className='col-12 col-sm-6 col-lg-4 mt-2'>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>
                                            <img src={routerImage} style={{ width: '50px' }} alt='' />
                                        </Card.Title>
                                        <Card.Subtitle className="mb-3 text-muted">تنظیمات روتر</Card.Subtitle>
                                        <Card.Text className='ltr mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>IP Address:</small>
                                            <small className='mr-2 text-muted'>{customer.server_address || '-----'}</small>
                                        </Card.Text>
                                        <Card.Text className='ltr mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>Port:</small>
                                            <small className='mr-2 text-muted'>{customer.server_port || '-----'}</small>
                                        </Card.Text>
                                        <Card.Text className='ltr mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>DHCP:</small>
                                            <small className='mr-2 text-muted'>{customer.dhcpRange || '-----'}</small>
                                        </Card.Text>
                                        <Card.Text className='ltr mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>SSID:</small>
                                            <small className='mr-2 text-muted'>{customer.RouterSSID || '-----'}</small>
                                        </Card.Text>
                                        <Card.Text className='ltr mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>Password:</small>
                                            <small className='mr-2 text-muted'>{customer.RouterPSK || '-----'}</small>
                                        </Card.Text>
                                        <div className='text-muted d-flex align-items-end'>
                                            <img src={envelopeImage} alt='' style={{ width: '45px' }} />
                                            <div className='text-muted my-1 mx-2 d-flex align-items-end w-100' style={{ fontSize: '.7rem' }}>
                                                <span>باقیمانده اعتبار :</span>
                                                <span className='ml-2'>{toPersian(priceFormat(customer.sms.wallet))} ریال</span>
                                                <button className='btn btn-sm btn-warning d-flex align-items-center p-0 m-0 justify-content-center align-self-center ml-auto'
                                                    style={{ width: '25px', height: '25px' }}
                                                    onClick={setCustomerForSmsPanel}
                                                >
                                                    <i className='fa fa-pencil fs-6 '></i>

                                                </button>
                                            </div>
                                        </div>

                                        <Card.Text className='rtl my-1' style={{ fontSize: '.8rem' }}>
                                            <small>قالب پیام عضویت مشتری:</small>
                                            <small className='ml-2 text-muted'>{customer.sms.customerMembership || '-----'}</small>
                                        </Card.Text>
                                        <Card.Text className='rtl my-1' style={{ fontSize: '.8rem' }}>
                                            <small>قالب باقیمانده اعتبار راننده:</small>
                                            <small className='ml-2 text-muted'>{customer.sms.driverRemain || '-----'}</small>
                                        </Card.Text>
                                        <Card.Text className='rtl mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>قالب افزایش اعتبار فیش راننده:</small>
                                            <small className='ml-2 text-muted'>{customer.sms.addDriverFish || '-----'}</small>
                                        </Card.Text>
                                        <Card.Text className='rtl mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>قالب کاهش اعتبار فیش راننده:</small>
                                            <small className='ml-2 text-muted'>{customer.sms.reduceDriverFish || '-----'}</small>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-12 col-sm-6 col-lg-4 mt-2'>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>
                                            <img src={ordersImage} style={{ width: '50px' }} alt='' />
                                        </Card.Title>
                                        <Card.Subtitle className="mb-3 text-muted">تنظیمات سفارشات</Card.Subtitle>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>تجمیع سفارشات:</small>
                                            <small className={`ml-3 ${customer.combineOrders ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.combineOrders ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>مدت زمان تحویل سفارش:</small>
                                            <small className={`ml-3 ${customer.orderTimeStatus ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.orderTimeStatus ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>حداقل زمان تحویل:</small>
                                            <small className='ml-2 text-muted'>{customer.minOrderTime} دقیقه</small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>حداکثر زمان تحویل:</small>
                                            <small className='ml-2 text-muted'>{customer.maxOrderTime} دقیقه</small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>نوع پرداخت:</small>
                                            <small className='ml-2 text-muted'>
                                                {customer.paymentType === 'end' ? 'انتها' : customer.paymentType === 'start' ? 'ابتدا' : 'ابتدا و انتها'}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>واحد پول:</small>
                                            <small className='ml-2 text-muted'>
                                                {customer.currencyType}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>مالیات بر ارزش افزوده:</small>
                                            <small className='ml-2 text-muted'>
                                                {customer.taxHandler === 'custom' ? 'اعمال دستی' : customer.taxHandler === 'auto' ? 'اعمال اتوماتیک' : 'غیرفعال'}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>اتمام سفارش بر اساس:</small>
                                            <small className='ml-2 text-muted'>
                                                {customer.orderTimeType === 'doneTime' ? 'زمان اتمام سفارش' : customer.orderTimeType === 'createTime' ? 'زمان ثبت سفارش' : 'زمان اتمام و پایان روز کاری'}
                                            </small>
                                        </Card.Text>
                                        <div className='' style={{ fontSize: '.8rem' }}>
                                            <div className='text-muted d-flex align-items-end'>
                                                <img src={backupImage} alt='' style={{ width: '50px' }} />
                                                <span> فایل پشتیبان</span>
                                            </div>
                                            {
                                                customer.backupName ?
                                                    <div className='text-right d-flex justify-content-end align-items-center' style={{ cursor: 'default' }}
                                                        onClick={() => handleDownloadBackup(customer.backupName)}
                                                    >
                                                        <div className=''>
                                                            <span className='mr-2' style={{ fontSize: '.65rem' }}>{(customer.backupName)}</span>
                                                            <span className='mr-2' style={{ fontSize: '.65rem' }}>{(customer.backupSize)} MB</span>
                                                        </div>
                                                        <img src={zipImage} alt='' style={{ width: '30px' }} />
                                                    </div>
                                                    :
                                                    <div className='text-danger text-right'>ندارد</div>
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>

                            </div>
                            <div className='col-12 col-sm-6 col-lg-4 mt-2'>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>
                                            <img src={settingImage} style={{ width: '50px' }} alt='' />
                                        </Card.Title>
                                        <Card.Subtitle className="mb-3 text-muted">تنظیمات و قابلیت های برنامه</Card.Subtitle>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>منوی آنلاین:</small>
                                            <small className={`ml-3 ${customer.onlineMenu ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.onlineMenu ? 'check' : 'times'}`}></i>}
                                            </small>
                                            {
                                                customer.onlineMenu &&
                                                <button className='btn btn-sm btn-warning p-0 px-1 ml-3'
                                                    onClick={setCustomerForMenu}
                                                >
                                                    <i className='fa fa-eye'></i>
                                                </button>
                                            }
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>احضار گارسون:</small>
                                            <small className={`ml-3 ${customer.pager ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.pager ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>چند زبانه:</small>
                                            <small className={`ml-3 ${customer.multiLanguage ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.multiLanguage ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>عدم نمایش حذفیات:</small>
                                            <small className={`ml-3 ${customer.hideRemovedOrders ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.hideRemovedOrders ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>ارتباط بی سیم:</small>
                                            <small className={`ml-3 ${customer.wakieTakie ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.wakieTakie ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>بایگانی سفارش:</small>
                                            <small className={`ml-3 ${customer.archiveOrder ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.archiveOrder ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>الزامی بودن انتخاب نفرات:</small>
                                            <small className={`ml-3 ${customer.forcePeopleCount ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.forcePeopleCount ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>باشگاه مشتریان:</small>
                                            <small className={`ml-3 ${customer.customerClub ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.customerClub ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>باشگاه رانندگان:</small>
                                            <small className={`ml-3 ${customer.driverClub ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.driverClub ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>احضار گارسون آنلاین:</small>
                                            <small className={`ml-3 ${customer.onlinePage ? 'text-success' : 'text-danger'}`}>
                                                {<i className={`fa fa-${customer.onlinePage ? 'check' : 'times'}`}></i>}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>شروع ساعت کاری:</small>
                                            <small className='ml-2 text-muted'>
                                                {toPersian(moment(Date.now()).utc(false).add('3.5', 'hours').startOf('day').add('milliseconds', customer.startWorking).format('HH:mm'))}
                                            </small>
                                        </Card.Text>
                                        <Card.Text className='mb-1' style={{ fontSize: '.8rem' }}>
                                            <small>پایان ساعت کاری:</small>
                                            <small className='ml-2 text-muted'>
                                                {toPersian(moment(Date.now()).utc(false).add('3.5', 'hours').startOf('day').add('milliseconds', customer.endWorking).format('HH:mm'))}
                                            </small>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-12 col-sm-6 col-lg-4 mt-2'>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>
                                            <img src={printerImage} style={{ width: '50px' }} alt='' />
                                        </Card.Title>
                                        <Card.Subtitle className="mb-3 text-muted">پرینتر و سرویس چاپ</Card.Subtitle>
                                        <Alert variant={'primary'} className=' mb-1'>
                                            <small>سرویس های چاپ</small>
                                            {
                                                getPrintServices().map((service, index) =>
                                                    service ?
                                                        <div key={index} style={{ fontSize: '.7rem' }}>
                                                            {index + 1} {service}
                                                        </div> : null
                                                )
                                            }
                                            {
                                                !hasPrintServices() &&
                                                <div style={{ fontSize: '.8rem' }}><small>سرویسی ثبت نشده است</small></div>
                                            }
                                            <div style={{ fontSize: '.7rem', marginTop: '5px' }}>زمان چاپ :
                                                <span className='ml-2'>{customer.firstPrintMode === 'onOrder' ? 'هنگام ثبت سفارش' : 'هنگام تأیید سفارش'}</span>
                                            </div>
                                        </Alert>
                                        <Alert variant={'primary'} className=' mb-1'>
                                            <small>پرینترها</small>
                                            {
                                                (customer.osPrinters && customer.osPrinters.length) ?
                                                    customer.osPrinters.map((printer, index) =>
                                                        <div key={index} style={{ fontSize: '.7rem' }} className='mt-1'>
                                                            <div>
                                                                {index + 1}- {printer.name} {printer.label ? (printer.label) : null}
                                                            </div>
                                                            {
                                                                printer.fishes.map((fish, j) =>
                                                                    <div key={j} style={{ fontSize: '.55rem' }} className='rtl my-1'>
                                                                        {getServiceName(fish.type)} - {`${fish.size} سایز`} - {`${fish.count} عدد`} - {`چاپ فوری`} <i className={`fa ${fish.firstprint ? 'fa-check' : 'fa-times'}`}></i> - {`offset: ${fish.offset} mm`}
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    ) :
                                                    <div style={{ fontSize: '.8rem' }}><small>پرینتری ثبت نشده است</small></div>
                                            }
                                        </Alert>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-12 col-sm-6 col-lg-4 mt-2'>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>
                                            <img src={pcposImage} style={{ width: '50px' }} alt='' />
                                        </Card.Title>
                                        <Card.Subtitle className="mb-3 text-muted d-flex justify-content-between">
                                            <div>دریافتی از مجموعه</div>
                                            <button className='btn btn-sm btn-warning d-flex align-items-center me-3 p-0 justify-content-center align-self-center'
                                                style={{ width: '25px', height: '25px' }}
                                                onClick={setCustomerForPayment}
                                            >
                                                <i className='fa fa-pencil fs-6 '></i>

                                            </button>
                                        </Card.Subtitle>
                                        {
                                            (customer.payment && customer.payment.length) ?
                                                customer.payment.map((item, index) =>
                                                    <Alert variant={'success'} className=' mb-1' key={index}>
                                                        <div className='d-flex flex-wrap' style={{ fontSize: '.7rem' }}>
                                                            <div className='col-6'>
                                                                نوع پرداخت
                                                            </div>
                                                            <div className='col-6'>
                                                                {item.type === 'cash' ? 'نقدی' : 'چک'}
                                                            </div>
                                                            <div className='col-6'>
                                                                مبلغ پرداختی
                                                            </div>
                                                            <div className='col-6'>
                                                                {toPersian(priceFormat(String(item.price)))} تومان
                                                            </div>
                                                            <div className='col-6'>
                                                                تاریخ پرداخت
                                                            </div>
                                                            <div className='col-6'>
                                                                {
                                                                    toPersian(moment(item.dateTimeStamp).utc(false).add('3.5', 'hours').format('jYYYY/jMM/jDD'))
                                                                }
                                                            </div>
                                                            <div className='col-6'>
                                                                وضعیت
                                                            </div>
                                                            <div className='col-6'>
                                                                {
                                                                    item.done ?
                                                                        <small className=''>پرداخت شده</small>
                                                                        :
                                                                        <small className='text-danger'>پرداخت نشده</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </Alert>
                                                )
                                                :
                                                <Card.Text className=' mb-1'>
                                                    <small className='text-danger'>پرداختی ثبت نشده است</small>
                                                </Card.Text>

                                        }

                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-12 col-sm-6 col-lg-4 mt-2'>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>
                                            <img src={lockImage} style={{ width: '40px' }} alt='' />
                                        </Card.Title>
                                        <Card.Subtitle className="mb-3 text-muted d-flex justify-content-between">
                                            <div>لایسنس و توضیحات</div>
                                            {
                                                admin === 'Mahdi' &&
                                                <button className='btn btn-sm btn-warning d-flex align-items-center me-3 p-0 justify-content-center align-self-center'
                                                    style={{ width: '25px', height: '25px' }}
                                                    onClick={setCustomerForLicense}
                                                >
                                                    <i className='fa fa-key fs-6 '></i>

                                                </button>

                                            }
                                        </Card.Subtitle>
                                        {
                                            customer.license ?
                                                <React.Fragment>
                                                    {
                                                        customer.expireTimeStamp > Date.now() ?
                                                            <Alert variant={'success'} className=' mb-1'>
                                                                <div className='d-flex justify-content-between' style={{ fontSize: '.7rem' }}>
                                                                    <div className=''>
                                                                        شماره اشتراک:
                                                                    </div>
                                                                    <div className=''>
                                                                        {String(customer.subscriptionNumber || 'وارد نشده').toUpperCase()}
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex ltr align-items-center justify-content-between mt-2'>
                                                                    <div style={{ fontSize: '.6rem' }}>{customer.license}</div>
                                                                    <div>
                                                                        <CopyToClipboard text={customer.license} onCopy={() => toast.success('لایسنس در کلیپ بورد کپی شد')}>
                                                                            <button className='btn btn-sm btn-success d-flex align-items-center mr-1 p-0  justify-content-center align-self-center'
                                                                                style={{ width: '25px', height: '25px' }}
                                                                            >
                                                                                <i className='fa fa-clipboard fs-6 '></i>

                                                                            </button>
                                                                        </CopyToClipboard>
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex justify-content-between mt-2' style={{ fontSize: '.7rem' }}>
                                                                    <div className=''>
                                                                        تاریخ انقضا:
                                                                    </div>
                                                                    <div className=''>
                                                                        {toPersian(moment(customer.expireTimeStamp).utc(false).add('3.5', 'hours').format('jYYYY/jMM/jDD'))}

                                                                    </div>
                                                                </div>
                                                            </Alert> :
                                                            <Alert variant={'danger'} className=' mb-1'>
                                                                <div className='d-flex justify-content-between' style={{ fontSize: '.7rem' }}>
                                                                    <div className=''>
                                                                        شماره اشتراک:
                                                                    </div>
                                                                    <div className=''>
                                                                        {String(customer.subscriptionNumber || 'وارد نشده').toUpperCase()}
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex ltr align-items-center justify-content-between mt-2'>
                                                                    <div style={{ fontSize: '.6rem' }}>{customer.license}</div>
                                                                    <div>
                                                                        <CopyToClipboard text={customer.license} onCopy={() => toast.success('لایسنس در کلیپ بورد کپی شد')}>
                                                                            <button className='btn btn-sm btn-success d-flex align-items-center mr-1 p-0 justify-content-center align-self-center'
                                                                                style={{ width: '25px', height: '25px' }}
                                                                            >
                                                                                <i className='fa fa-clipboard fs-6 '></i>

                                                                            </button>
                                                                        </CopyToClipboard>
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex justify-content-between mt-2' style={{ fontSize: '.7rem' }}>
                                                                    <div className=''>
                                                                        تاریخ انقضا:
                                                                    </div>
                                                                    <div className=''>
                                                                        {toPersian(moment(customer.expireTimeStamp).utc(false).add('3.5', 'hours').format('jYYYY/jMM/jDD'))}

                                                                    </div>

                                                                </div>
                                                            </Alert>
                                                    }
                                                </React.Fragment>
                                                :
                                                <Alert variant={'danger'} className='text-center'>
                                                    <div className='d-flex justify-content-between' style={{ fontSize: '.7rem' }}>
                                                        <div className=''>
                                                            شماره اشتراک:
                                                        </div>
                                                        <div className=''>
                                                            {String(customer.subscriptionNumber || 'وارد نشده').toUpperCase()}
                                                        </div>
                                                    </div>
                                                    <Card.Text className=' mb-1'>
                                                        <small>لایسنس یافت نشد</small>
                                                    </Card.Text>
                                                </Alert>

                                        }
                                        <div className=' my-3' style={{ fontSize: '.7rem' }}>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <span>
                                                    <i className='fa fa-comment mr-2'></i>
                                                    توضیحات تکمیلی:
                                                </span>
                                                <button className='btn btn-sm btn-warning d-flex align-items-center me-3 p-0 justify-content-center align-self-center'
                                                    style={{ width: '25px', height: '25px' }}
                                                    onClick={setCustomerForInfo}
                                                >
                                                    <i className='fa fa-pencil fs-6 '></i>

                                                </button>
                                            </div>
                                            <p className='text-muted ml-2 mt-1' style={{ whiteSpace: 'pre-wrap' }}>
                                                {toPersian(String(customer.info || '------'))}
                                            </p>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </div>
                            <button className=' mt-3 mb-2 btn btn-sm btn-danger d-flex align-items-center justify-content-center align-self-center'
                                onClick={setCustomerForDelete}
                            >
                                <i className='fa fa-trash mr-2  '></i>
                                حذف مشتری
                            </button>
                        </div>
                    </div>
                </Collapse>
            </section>
        </div>
    );
}

export default Customer;